<template>
  <ul class="ml-6" :class="format === 'ordered' ? 'list-decimal' : 'list-disc'">
    <li v-for="(child, i) in children" :key="i" :class="{ 'list-none': child.type === NodeType.LIST }">
      <UiRichTextContentParagraph v-if="child.type === NodeType.LIST_ITEM" :children="child.children" />
      <UiRichTextContentList
        v-else-if="child.type === NodeType.LIST"
        :children="child.children"
        :format="child.format"
      />
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { RichTextContentListProps } from '~/components/ui/RichTextContent/types';

import { NodeType } from '~/stores/cms/types';

defineProps<RichTextContentListProps>();
</script>
